import React from 'react'
import '../styles/_index.scss'
import StaticBatchesPage from "./StaticBatchesPage"

function StaticBatchesContainer(props) {
    return (
        <div className='StaticBatchesContainer'>
            <StaticBatchesPage {...props}/>
        </div>
    )
}

export default StaticBatchesContainer
